import { Helmet } from 'react-helmet-async';
import MenuTypeListView from 'src/sections/menutype/view/menutype-list-view';
// sections
import { UserListView } from 'src/sections/user/view';

// ----------------------------------------------------------------------

export default function MenuTypeListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Tipos de Menu</title>
      </Helmet>

      <MenuTypeListView />
    </>
  );
}
